import {baseAxios} from '../helper/axiosHelper';

export const newsletterService = {
    insertNewsletter,
    updateNewsletter,
    deleteNewsletter,
    getAllNewsletter,
    insertTemplate,
    updateTemplate,
    deleteTemplate,
    getAllTemplates,
    insertReclist,
    updateReclist,
    deleteReclist,
    getAllReclists,
    insertReclistMem,
    updateReclistMem,
    deleteReclistMem,
    getRecUserData,
    getNewsletterPrev
};

function insertNewsletter(data) {

    return baseAxios.post('newsletter/newsletter',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateNewsletter(data) {

    return baseAxios.put('newsletter/newsletter',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteNewsletter(id) {

    return baseAxios.delete('newsletter/newsletter',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getAllNewsletter() {

    return baseAxios.get('newsletter/newsletter/all')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getNewsletterPrev(id) {

    return baseAxios.get('newsletter/newsletter/preview',{params: {id: id}})
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function insertTemplate(data) {

    return baseAxios.post('newsletter/template',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateTemplate(data) {

    return baseAxios.put('newsletter/template',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteTemplate(id) {

    return baseAxios.delete('newsletter/template',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getAllTemplates() {

    return baseAxios.get('newsletter/template/all')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}




function insertReclist(data) {

    return baseAxios.post('newsletter/reclist',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateReclist(data) {

    return baseAxios.put('newsletter/reclist',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteReclist(id) {

    return baseAxios.delete('newsletter/reclist',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getAllReclists() {

    return baseAxios.get('newsletter/reclist/all')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function getRecUserData() {

    return baseAxios.get('newsletter/reclist/rec_userdata')
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}



function insertReclistMem(data) {

    return baseAxios.post('newsletter/reclistmem',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}
function updateReclistMem(data) {

    return baseAxios.put('newsletter/reclistmem',data)
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

function deleteReclistMem(id) {

    return baseAxios.delete('newsletter/reclistmem',{params: {id: id}} )
    .then((response) =>
    {
        return response;
    })
    .catch(function (error) {
        return error.response;
    });
}

